// extracted by mini-css-extract-plugin
export default {"wrapper":"VehicleConditionDiscount_wrapper__3sFFb"};